module.exports = __webpack_public_path__ + "img/pk-sd.b6f892cb.svg";